import axios from "axios";
import { userManagerFactory } from "../services/oidc/utils/userManager";

const api = (apiUrl, amlJavaApi) => ({
  exec: ({ method, data, url, amlJava }) =>
    userManagerFactory()
      .getUser()
      .then((rez) => {
        const formData = new FormData();

        Object.keys(data).forEach((key) => {
          if (Array.isArray(data[key])) {
            for (var i = 0; i < data[key].length; i++) {
              formData.append(key, data[key][i]);
            }
          } else {
            formData.append(key, data[key]);
          }
        });

        return axios({
          method,
          url: `${amlJava ? amlJavaApi : apiUrl}/${url}`,
          crossdomain: true,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${rez.access_token}`,
            OrganizationName: localStorage.getItem("orgName"),
            TimeZoneOffset: `${-(new Date().getTimezoneOffset() / 60)}`,
          },
          withCredentials: true,
        });
      }),
});
export default api;



// WEBPACK FOOTER //
// ./src/api-services/formDataApi.js